import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/EmotionSection.css';

const EmotionSection = () => {
  const { t } = useTranslation();
  // 当前活跃的轮播索引
  const [activeIndex, setActiveIndex] = useState(0);

  // 定义轮播数据的函数，确保在语言变化时更新
  const getSlides = () => [
    {
      image: '/images/page8/8-1.png',
      text: t('moreThanCute.carousel.happyWithYou')
    },
    {
      image: '/images/page8/8-2.png',
      text: t('moreThanCute.carousel.dontIgnore')

    },
    {
      image: '/images/page8/8-3.png',
      text: t('moreThanCute.carousel.eatTime')
    },
    {
      image: '/images/page8/8-4.png',
      text: t('moreThanCute.carousel.fireball')
    }
  ];

  const slides = getSlides();

  // 自动轮播效果
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % slides.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [slides.length]);

  // 切换到指定的轮播索引
  const goToSlide = (index) => {
    setActiveIndex(index);
  };

  return (
    <section className="emotion-section">
      <div className="emotion-title-container">
        <h2 className="emotion-title">{t('moreThanCute.interaction')}</h2>
        <div className="emotion-subtitle">
          <p className="subtitle-line">{t('moreThanCute.feelsWhat')}</p>
        </div>
      </div>

      <div className="carousel-container">
        <div className="carousel-inner">
          {slides.map((slide, index) => (
            <div
              key={index}
              className={`carousel-slide ${index === activeIndex ? 'active' : ''}`}
            >
              <div className="slide-image-container">
                <img 
                  src={slide.image} 
                  alt={`Emotion ${index + 1}`} 
                  className="slide-image" 
                />
                <div className="slide-gradient"></div>
                <div className="slide-text">{slide.text}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="carousel-dots">
          {slides.map((_, index) => (
            <button
              key={index}
              className={`carousel-dot ${index === activeIndex ? 'active' : ''}`}
              onClick={() => goToSlide(index)}
              aria-label={`Switch to slide ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default EmotionSection; 